import { v4 as uuid } from 'uuid';
import Cookies from 'js-cookie';
import axios from 'axios';

export class JuntoAnalyticsService {
  navigationEventAdapter = null;

  keys = {
    userDeviceIdKey: 'junto-analytics/user-device-id',
    sessionIdKey: 'junto-analytics/session-id',
    referUrlKey: 'junto-analytics/url',
  };

  // Initialize cookies needed to track the user
  initializeJuntoAnalytics() {
    const url = window.origin;
    this.initializeUserDeviceId();
    this.initializeSessionId(url);
  }

  // Sets the adapter to build custom payload when page changes
  configurePageNavigationAnalytics(adapter) {
    this.navigationEventAdapter = adapter;
  }

  pageChanged = () => {
    if (!this.navigationEventAdapter) return;

    try {
      // ensure that the cookies were initialized
      if (!this.hasSessionId()) this.createNewSessionId();
      if (!this.hasUserDeviceId()) this.createNewUserDeviceId();

      // build specific data
      const payload = this.navigationEventAdapter.buildPayload(
        this.getUserDeviceId,
        this.getSessionId
      );

      // send to the server
      if (payload && payload.userId && payload.sessionId) this.sendEvent(payload);
    } catch {
      console.warn('junto-analytics page-changed out of service');
    }
  };

  // If the userId doesn't exists, it will create a new one
  initializeUserDeviceId = () => {
    if (!this.hasUserDeviceId()) this.createNewUserDeviceId(uuid());
  };

  // If the sessionId doesn't exists, it will create a new one
  // If the sessionId exists but it is from the same origin, it will create a new one
  // Should always update the referUrl
  initializeSessionId = url => {
    if (!this.hasSessionId() || (this.hasSessionId() && this.isSessionFromThisOrigin(url))) {
      this.createNewSessionId(uuid());
    }

    this.setReferUrl(url);
  };

  sendCustomEvent = async (eventData, adapter, eventName) => {
    try {
      const builtPayload = adapter.buildPayload(eventData);

      const event = {
        userId: this.getUserDeviceId(),
        sessionId: this.getSessionId(),
        eventSourceUrl: window.location.href,
        eventName,
        ...builtPayload,
      };

      this.sendEvent(event);
    } catch {
      console.warn('failed to send custom event');
    }
  };

  // Under this line, we have the infrastructure code

  sendEvent = async payload => {
    axios.post(`${process.env.REACT_APP_ANALYTICS_JUNTO_URL}/v1/analytics`, payload);
  };

  isSessionFromThisOrigin = currentUrl => currentUrl === this.getReferUrl();

  hasUserDeviceId = () => this.getUserDeviceId() !== undefined;

  getUserDeviceId = () => Cookies.get(this.keys.userDeviceIdKey);

  createNewUserDeviceId = id =>
    Cookies.set(this.keys.userDeviceIdKey, id, {
      expires: 5000,
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    });

  hasSessionId = () => this.getSessionId() !== undefined;

  getSessionId = () => Cookies.get(this.keys.sessionIdKey);

  createNewSessionId = id =>
    Cookies.set(this.keys.sessionIdKey, id, {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    });

  getReferUrl = () => Cookies.get(this.keys.referUrlKey);

  setReferUrl = url =>
    Cookies.set(this.keys.referUrlKey, url, {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    });
}

const service = new JuntoAnalyticsService();
export default service;
